import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { Snackbar, Alert } from '@mui/material';
import { clearErrors } from '../Redux/ActionCreators/errorAction';
import { useDispatch } from 'react-redux';
import Footer from './footer';
import { useTranslation } from 'react-i18next';

export default function CandidateHeader() {

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { candidateDetails, testDetails } = useSelector(state => state.candidateTest);
    const error = useSelector(state => state.error);

    const isNotebook = sessionStorage.getItem("isNotebook") === "true";


    const snackClosed = () => {
        dispatch(clearErrors());
    }

    return (
        <div>
            <div className='candidate-holder' style={{ overflow: 'auto', maxHeight: '100vh', background:'#EDF2F7', minHeight: '100vh' }}>
                <div className='candidate-header d-flex flex-column align-items-center' style={{ zIndex: 1, borderBottom: "1px solid #e8eaed", paddingBottom:'20px' }}>
                    {!isNotebook &&
                        <>
                            {candidateDetails?.logoImage  ? <img src={candidateDetails?.logoImage} alt='' width='auto' style={{height:'50px'}} /> : <img src='/images/logo.png' width='auto' style={{height:'50px'}} alt='' />}
                        </>
                    }
                </div>
                <div className='layout-container' style={{minHeight:'70vh'}}>
                    <Snackbar
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
                        open={error.successMessage}
                        autoHideDuration={3000}
                        onClose={snackClosed}
                    >
                        <Alert onClose={snackClosed} severity="error" sx={{ width: '100%' }}>
                            {error.successMessageText}
                        </Alert>
                    </Snackbar>
                    <Snackbar
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
                        open={error.successEnable}
                        onClose={() => snackClosed()}
                        autoHideDuration={4000}
                    >
                        <Alert onClose={snackClosed} severity="success" sx={{ width: '100%' }}>
                            {error.successMessageText}
                        </Alert>
                    </Snackbar>
                    <React.Suspense fallback={''}>
                        <Outlet />
                    </React.Suspense>
                </div>
                <div className='text-center mt-5 mb-3'>
                    <Footer />
                </div>
            </div>
            <div className="candidate-holder-sm">
                <p>Assessment needs to be taken on Laptop or desktop.</p>
            </div>
        </div>
    )
}
